import "./global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import "antd/dist/reset.css";
import "normalize.css";

import React, { StrictMode } from "react";
import Router from "./router/index";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import Colors from "./constants/colors";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement
);

// antd tokens aligned with the user-web theme
const antdTheme = {
  token: {
    colorPrimary: Colors.primaryBlue,
    colorInfo: Colors.info,
    colorSuccess: Colors.success,
    colorWarning: Colors.warning,
    colorError: Colors.error,
    colorText: Colors.textPrimary,
    colorTextSecondary: Colors.textTertiary,
    colorBorder: Colors.gray200,
    colorBgLayout: Colors.screenBackground,
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 12,
  },
};

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={antdTheme}>
        <Router />
      </ConfigProvider>
    </Provider>
  );
}

export default App;
